module.exports = __webpack_public_path__ + "media/images/icon-practices-0e3d44d8334befda3af5b7a48d874777002c4ac32284449168bbab53cec37715.svg";